<div class="wallboardViewSlide" [attr.mid]="moduleKey" *ngIf="imageState !== undefined">
    <div class="wvImageItem" [ngStyle]="{ 'background':'url(../Admin/ImageResizer.aspx?imgid=' + imageState?.UploadedImageID +'&w=' + imgWidth + '&h=' + imgHeight + ') center center no-repeat' }"></div>
</div>
